export enum LorenAlarmsColumns {
  ASSET = "asset",
  GROUPS = "groups",
  PARAMETER = "parameter",
  AUTOMATION_RULE = "automationRule",
  START = "start",
  PROCESSED_TIME = "processedTime",
  PROCESSED = "processed",
  STATUS = "status",
}
